import { render, staticRenderFns } from "./formOca.vue?vue&type=template&id=59868883&"
import script from "./formOca.vue?vue&type=script&lang=js&"
export * from "./formOca.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports